<template>
  <!-- 我的订单页面 -->
  <div class="container">
    <div class="row">
      <div class="col-md-8" style="margin: 0 auto">
        <Search :pages="routeLive" />
        <mt-navbar v-model="selected" @input="getCurrentSelect">
          <mt-tab-item id="buy">已购直播</mt-tab-item>
          <mt-tab-item id="enroll">我的报名</mt-tab-item>
        </mt-navbar>

        <!-- tab-container -->
        <mt-tab-container v-model="selected">
          <mt-tab-container-item id="buy">
            <!-- <div v-show="orderList.length <= 0" class="noOrder">
              <p>您暂时还未购买直播!</p>
            </div> -->
            <div
              class="course"
              v-for="(item, index) in orderList"
              :key="index"
              @click="getDetail(item.liveId)"
            >
              <img class="course_img" :src="item.liveCoverImg" />
              <div class="course_text">
                <p class="course_title">{{ item.liveName }}</p>
                <!-- <p class="course_date" v-if="item.payTime">{{item.payTime.substring(0,11)}}购买</p> -->
                <!-- <button size="normal" type="primary" class="course_study">去学习</button>
                <span></span>-->
                <div class="infoItemDes2" v-if="item.liveStatus === 0">
                  <span
                    >开始时间：{{ item.liveStartTime.substring(0, 19) }}</span
                  >
                </div>
                <div class="infoItemDes2" v-if="item.liveStatus === 1">
                  <span>结束时间：{{ item.liveEndTime.substring(0, 19) }}</span>
                </div>
                <div>
                  <span class="course_study">去学习</span>
                </div>
              </div>
            </div>
            <div
              v-if="orderPageIndex < orderDataForm.totalPage"
              style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
              "
              @click="loadMoreOrder"
            >
              点击加载更多...
            </div>
            <div
              v-else
              style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 40px;
                padding-bottom: 50px;
              "
            >
              暂无更多数据...
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item id="enroll">
            <!-- <div v-show="enrollList.length <= 0" class="noOrder">
              <p>您暂时还未报名直播!</p>
            </div> -->
            <div
              v-for="(item, index) in enrollList"
              :key="index"
              class="course"
              @click="getDetail(item.liveId)"
            >
              <div class="liveImg">
                <img class="course_img" :src="item.liveCoverImg" alt />
                <div class="liveStatus">
                  {{
                    item.liveStatus === 0
                      ? '即将直播'
                      : item.liveStatus === 1
                      ? '直播中'
                      : '历史直播'
                  }}
                </div>
              </div>
              <!-- <img class="course_img" :src="item.liveCoverImg" /> -->
              <div class="course_text">
                <p class="course_title">{{ item.liveName }}</p>
                <!-- <p class="course_date" v-if="item.signUpTime">{{item.signUpTime.substring(0,11)}}报名</p> -->
                <!-- <button type="primary" class="course_study">去学习</button> -->

                <div class="infoItemDes2" v-if="item.liveStatus === 0">
                  <span
                    >开始时间：{{ item.liveStartTime.substring(0, 19) }}</span
                  >
                </div>
                <div class="infoItemDes2" v-if="item.liveStatus === 1">
                  <span>结束时间：{{ item.liveEndTime.substring(0, 19) }}</span>
                </div>
                <div>
                  <span class="course_study">去学习</span>
                </div>
              </div>
            </div>
            <div
              v-if="enrollPageIndex < enrollDataForm.totalPage"
              style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
              "
              @click="loadMoreEnroll"
            >
              点击加载更多...
            </div>
            <div
              v-else
              style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 40px;
                padding-bottom: 50px;
              "
            >
              暂无更多数据...
            </div>
          </mt-tab-container-item>
        </mt-tab-container>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '../../components/Search'
export default {
  beforeRouteLeave(to, from, next) {
    if (to.fullPath.indexOf('/details?liveId=') == -1) {
      this.$store.commit('changeSelectedOrder', 'buy')
    } else {
      this.$store.commit('changeSelectedOrder', this.selected)
    }
    next()
  },
  components: { Search },
  data() {
    return {
      selected: 'buy',
      orderList: [],
      enrollList: [],
      orderDataForm: {
        currPage: 0,
        pageSize: 0,
        totalCount: 0,
        totalPage: 0
      },
      enrollDataForm: {
        currPage: 0,
        pageSize: 0,
        totalCount: 0,
        totalPage: 0
      },
      orderPageIndex: 1,
      enrollPageIndex: 1,
      busy: false,
      user: {},
      routeLive: ''
    }
  },
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.userId = sessionStorage.getItem('userId')
    this.routeLive = sessionStorage.getItem('routeLive')
    let selectedOrder = localStorage.getItem('selectedOrder')
    selectedOrder ? (this.selected = selectedOrder) : (this.selected = 'buy')
    this.getOrderList()
    this.getEnrollList()
    this.noShare()
  },
  methods: {
    getCurrentSelect() {
      this.$store.commit('changeSelectedOrder', this.selected)
    },
    // 跳转到直播页面
    getDetail(liveId) {
      // this.$router.push({
      //   path: '/details',
      //   query: { liveId: liveId },
      // })
      const routeData = this.$router.resolve({
        path: '/details',
        query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    },
    // 加载更多
    loadMoreOrder() {
      const _this = this
      _this.orderPageIndex++
      if (_this.orderPageIndex <= _this.orderDataForm.totalPage) {
        _this.getOrderList(_this.user.mobile)
      }
    },
    // 加载更多
    loadMoreEnroll() {
      const _this = this
      _this.enrollPageIndex++
      if (_this.enrollPageIndex <= _this.enrollDataForm.totalPage) {
        _this.getEnrollList(_this.user.userId)
      }
    },
    // 获取订单列表
    getOrderList() {
      this.$http({
        url: `/live/live/getPayLives/${this.user.mobile}/${
          this.orderPageIndex
        }/${10}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.orderList = this.orderList.concat(data.data.records)
          this.orderDataForm.pageSize = data.data.pageSize
          this.orderDataForm.totalCount = data.data.total
          this.orderDataForm.currPage = data.data.pages
        } else {
          this.orderList = []
          this.orderPageIndex = 1
        }
      })
    },
    // 获取报名列表
    getEnrollList() {
      this.$http({
        url: '/live/userSignUp/querySignLives',
        method: 'get',
        params: {
          pageNo: this.enrollPageIndex,
          userId: this.userId,
          pageSize: 10
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.enrollList = this.enrollList.concat(data.data.records)
          this.enrollDataForm.pageSize = data.data.pageSize
          this.enrollDataForm.totalCount = data.data.total
          this.enrollDataForm.totalPage = data.data.pages
          this.enrollDataForm.currPage = data.data.current
        } else {
          this.enrollList = []
          this.enrollPageIndex = 1
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.infoItemDes2 {
  // line-height: 15px;
  color: #666;
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // margin: 5px 0;
}
.mint-navbar .mint-tab-item {
  padding-top: 5px;
}
.noOrder {
  text-align: center;
  height: 300px;
  font-size: 14px;
  line-height: 300px;
}
.course {
  margin: 0.5rem 15px;
  border-bottom: 1px solid #bfbfbf;
  padding-bottom: 0.5rem;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  .liveImg {
    position: relative;
    .liveStatus {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #fff;
      padding: 2px 1rem;
      border-radius: 1rem;
      font-size: 12px;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }
  .course_img {
    width: 100px;
    height: 75px;
    border-radius: 3px;
  }
  .course_text {
    margin-left: 2rem;
    width: 60%;
    line-height: 23px;
    .course_title {
      font-size: $font-title2;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .course_date {
      color: #666;
      font-size: 14px;
    }
    .course_study {
      border: 0;
      background-color: $theme-color;
      color: #fff;
      font-size: 12px;
      border-radius: 5px;
      line-height: 2;
      margin-top: 5px;
      padding: 3px 5px;
      // span {
      //   // float: right;
      //   padding: 2px 5px;
      //   color: #666;
      //   font-size: 14px;
      //   // margin-right: 10px;
      //   line-height: 25px;
      // }
    }
  }
}
/deep/ .mint-navbar .mint-tab-item.is-selected {
  margin-bottom: 3px;
}
</style>
